exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".welcome-container{\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: end;\n      align-content: flex-end;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-flow: wrap;\n      flex-flow: wrap;\n  width: 100%;\n  margin-bottom: 25px;\n}\n\n.welcome-box{\n    height: 100%;\n    cursor: pointer;\n}\n\n.logo{\n    position: relative;\n    height: 60%;\n    background: #f3f3f3;\n}\n\n.logo img {\n    position: absolute;\n    margin: auto;\n    height: 40%;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n.section{\n    margin: 10px;\n    height: 40%;\n}\n\n.section .action{\n    height: 100%;\n    font-size: 30px;\n}\n\n.section .info{\n    height: 10%;\n    display: none;\n}\n\n.section .link{\n    height: 10%;\n    display: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/welcome/welcome.component.css
// module id = 809
// module chunks = 0